export const ModeLogin = "login";
export const ModeSendVerificationCode = "send-verification-code";
export const ModeCheckVerificationCode = "check-verification-code";
export const ModeChangePassword = "change-password";